import { LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function UserMenu() {
  const { user, logout } = useAuth();

  if (!user) return null;

  const displayName = user.name ?? user.email;

  return (
    <div className="flex items-center gap-3">
      <div className="text-right leading-tight">
        <p className="text-sm font-medium text-ink-100 font-body truncate max-w-[12rem]">
          {displayName}
        </p>
        <p className="text-xs text-ink-500 font-body truncate max-w-[12rem]">{user.email}</p>
      </div>
      <button
        type="button"
        onClick={() => void logout()}
        aria-label="Sair"
        title="Sair"
        className="flex items-center justify-center min-w-[44px] min-h-[44px] rounded-xl glass-button text-ink-300 hover:text-ink-100 transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-400/50"
      >
        <LogOut className="w-4 h-4" aria-hidden="true" />
      </button>
    </div>
  );
}
